export { PLUGIN_KEY, PLUGIN_PRIORITY, Search } from "./search.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/search/index.mjs
// module id = 1546
// module chunks = 1